import {
    FETCH_HEART_RATE_REPORT_DAILY_ERROR,
    FETCH_HEART_RATE_REPORT_DAILY_FETCHING,
    FETCH_HEART_RATE_REPORT_DAILY_SUCCESS,
    FETCH_HEART_RATE_REPORT_DAILY,
    FETCH_HEART_RATE_REPORT_ONE_YEAR,
    FETCH_HEART_RATE_REPORT_ONE_YEAR_ERROR,
    FETCH_HEART_RATE_REPORT_ONE_YEAR_FETCHING,
    FETCH_HEART_RATE_REPORT_ONE_YEAR_SUCCESS
} from '../../actions/ActionTypes';

const initialState = {
    heartRateDailyData: [],
    heartRateDataFetching: false,
    heartRateDataFail: false,
    heartRateOneYearData: []
};

const fetchHeartRateDailyDataSuccess = (state, action) => {
    return {
        ...state,
        heartRateDailyData: action.data,
        heartRateDataFetching: false,
        heartRateDataFail: false
    };
};

const fetchHeartRateDataFetching = (state, action) => {
    return {
        ...state,
        heartRateDataFetching: true
    };
};

const fetchHeartRateDataFail = (state, action) => {
    return {
        ...state,
        heartRateDataFetching: false,
        heartRateDataFail: true
    };
};

const fetchHeartRateOneYearDataSuccess = (state, action) => {
    return {
        ...state,
        heartRateOneYearData: action.data,
        heartRateDataFetching: false,
        heartRateDataFail: false
    };
};

const handlers = {
    [FETCH_HEART_RATE_REPORT_DAILY_ERROR]: fetchHeartRateDataFail,
    [FETCH_HEART_RATE_REPORT_DAILY_SUCCESS]: fetchHeartRateDailyDataSuccess,
    [FETCH_HEART_RATE_REPORT_DAILY_FETCHING]: fetchHeartRateDataFetching,
    [FETCH_HEART_RATE_REPORT_ONE_YEAR_ERROR]: fetchHeartRateDataFail,
    [FETCH_HEART_RATE_REPORT_ONE_YEAR_FETCHING]: fetchHeartRateDataFetching,
    [FETCH_HEART_RATE_REPORT_ONE_YEAR_SUCCESS]: fetchHeartRateOneYearDataSuccess
};

export default function heartRateReport(state = initialState, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// action
export function fetchHeartRateReportDailyFormat(startDate, endDate) {
    return {
        type: FETCH_HEART_RATE_REPORT_DAILY,
        startDate: startDate,
        endDate: endDate
    };
}

export function fetchHeartRateReportOneYearFormat(endDate, numWeeks) {
    return {
        type: FETCH_HEART_RATE_REPORT_ONE_YEAR,
        endDate: endDate,
        numWeeks: numWeeks
    };
}

// get functions
export function getHeartRateDailyFormatData(state) {
    return state.heartRateReport.heartRateDailyData;
}

export function isHeartRateReportDataFetching(state) {
    return state.heartRateReport.heartRateDataFetching;
}

export function didHeartRateReportDataFail(state) {
    return state.heartRateReport.heartRateDataFail;
}

export function getHeartRateReportOneYearData(state) {
    return state.heartRateReport.heartRateOneYearData;
}
